import { FiClock, FiCalendar, FiDollarSign, FiFileText, FiSun, FiBarChart2, FiGrid, FiTrendingUp, FiCreditCard, FiTarget, FiSettings } from "react-icons/fi";

// Helper functions for dynamic dates
export function getMondayOfWeek() {
	let today = new Date();
	let dayOfWeek = today.getDay();
	let diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
	let monday = new Date(today.setDate(diff));
	let mondayISO = monday.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" });
	return mondayISO.replace(/\//g, "-");
}

export function getFirstDayOfMonth() {
	return new Intl.DateTimeFormat("en-US", {
		month: "2-digit",
		day: "2-digit",
		year: "numeric",
	})
		.format(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
		.replace(/\//g, "-");
}

// Navigation configuration - single source of truth
export const navConfig = [
	{
		id: "time-tracking",
		title: "Time Tracking",
		icon: FiClock,
		homePath: "/time-tracking",
		links: [
			{ to: "/logged-time-week/" + getMondayOfWeek(), label: "Week" },
			{ to: "/logged-time-month/" + getFirstDayOfMonth(), label: "Month" },
			{ to: "/logged-time-year/1-1-2024", label: "2024" },
		],
	},
	{
		id: "planning",
		title: "Planning",
		icon: FiCalendar,
		homePath: "/year-planning",
		links: [
			{ to: "/today", label: "Today" },
			{ to: "/week-planning", label: "Week" },
			{ to: "/year-sprint", label: "Sprint" },
			{ to: "/money-running", label: "Running" },
			{ to: "/year-view", label: "Year View" },
		],
	},
	{
		id: "money",
		title: "Money",
		icon: FiDollarSign,
		homePath: "/money",
		links: [
			{ to: "/budget-forecast", label: "Forecast" },
			{ to: "/spending-averages", label: "Averages" },
			{ to: "/accounts", label: "Accounts" },
			{ to: "/networth", label: "Net Worth" },
			{ to: "/ledger", label: "Ledger" },
			{ to: "/budget-items", label: "Budget Items" },
			{ to: "/accountBalance", label: "Balances" },
		],
	},
	{
		id: "invoicing",
		title: "Invoicing",
		icon: FiFileText,
		homePath: "/invoicing",
		links: [
			{ to: "/invoice-builder", label: "Builder" },
			{ to: "/invoice", label: "Preview" },
			{ to: "/invoices", label: "Invoices" },
			{ to: "/clients", label: "Clients" },
			{ to: "/projects", label: "Projects" },
		],
	},
	{
		id: "daily",
		title: "Daily",
		icon: FiSun,
		homePath: "/daily",
		links: [
			{ to: "/daily-all", label: "All" },
			{ to: "/daily-add", label: "Add" },
		],
	},
	{
		id: "reports",
		title: "Reports",
		icon: FiBarChart2,
		homePath: "/reports",
		links: [{ to: "/reports/retainer-audit", label: "Retainer Audit" }],
	},
	{
		id: "frontend",
		title: "Frontend",
		icon: FiGrid,
		homePath: "/frontend",
		links: [
			{ to: "/style-guide", label: "Style Guide" },
			{ to: "/home-style-guide", label: "Home Guide" },
			{ to: "/ux4", label: "UX Demo V4" },
		],
	},
];

// Parallax variant: individual icons per route, settings flyout for management pages
export const parallaxNavConfig = [
	{
		id: "forecast",
		title: "Forecast",
		icon: FiTrendingUp,
		homePath: "/budget-forecast",
		links: [],
	},
	{
		id: "averages",
		title: "Averages",
		icon: FiBarChart2,
		homePath: "/spending-averages",
		links: [],
	},
	{
		id: "accounts",
		title: "Accounts",
		icon: FiCreditCard,
		homePath: "/accounts",
		links: [],
	},
	{
		id: "networth",
		title: "Net Worth",
		icon: FiTarget,
		homePath: "/networth",
		links: [],
	},
	{
		id: "settings",
		title: "Settings",
		icon: FiSettings,
		homePath: "/ledger",
		links: [
			/*{ to: "/ledger", label: "Ledger" },*/
			{ to: "/budget-items", label: "Budget Items" },
			{ to: "/accountBalance", label: "Balances" },
		],
	},
];
